import { gql } from "@apollo/client";

import { CoachRating } from "@/components/pages_flexible/coach/CoachRating";
import { Card, CardContent } from "@/components/ui/card";
import { useGetCoachQuery } from "@/graphql";

export const GET_COACH = gql`
  query GetCoach($coachId: ID!) {
    coachById(coachId: $coachId) {
      id
      name
      photo
      slug
      about
      summary
      averageRating
    }
  }
`;

export function CoachDescriptionCard({ coachId }: { coachId: string }) {
  const { data, loading } = useGetCoachQuery({ variables: { coachId } });
  const coach = data?.coachById;

  if (loading) {
    return (
      <Card>
        <CardContent>
          <div className="flex animate-pulse">
            <div className="h-16 w-16 rounded-full bg-gray-300"></div>
            <div className="ml-4 flex-1 space-y-2">
              <div className="h-6 w-32 rounded bg-gray-300"></div>
              <div className="h-4 w-full rounded bg-gray-300"></div>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!coach) return null;

  return (
    <Card>
      <CardContent>
        <div className="flex">
          {coach.photo ? (
            <img
              src={coach.photo}
              alt={coach.name}
              className="h-16 w-16 rounded-full object-cover"
            />
          ) : (
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-200 text-gray-500">
              {coach.name.charAt(0)}
            </div>
          )}

          <div className="ml-4">
            <div className="flex gap-2">
              <div className="text-xl font-semibold text-gray-900">
                {coach.name}
              </div>
              <div className="flex items-center">
                <CoachRating rating={coach.averageRating} />
              </div>
            </div>

            {coach.about && (
              <p className="mt-1 text-sm font-normal">{coach.summary}</p>
            )}
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
